<template>
  <div>
    <section class="section9" :class="{ tech: pageView == 'tech' }">
      <div class="cont">
        <div class="contBx">
          <div class="contItems">
            <div class="contItem contItem3">
              <div class="item1">
                <h5 class="itemMainTitle">企业-技术支持</h5>
                <h6 class="itemSubTitle">
                  适用于客户技术支持、公司IT管理、<br />无人值守等场景
                </h6>
              </div>
              <div class="features">
                <div class="fitem">
                  <img
                    class="fitem_img"
                    src="@/assets/remoteSupport/price_check3@2x.png"
                    alt=""
                  />
                  <p class="fitem_text">标准版完整功能</p>
                </div>
                <div class="fitem">
                  <img
                    class="fitem_img"
                    src="@/assets/remoteSupport/price_check3@2x.png"
                    alt=""
                  />
                  <p class="fitem_text">可用SOS免安装客户端</p>
                </div>
                <div class="fitem fitemlast">
                  <img
                    class="fitem_img"
                    src="@/assets/remoteSupport/price_check3@2x.png"
                    alt=""
                  />
                  <p class="fitem_text">如需支持更多设备请咨询客户经理</p>
                </div>
              </div>
              <div class="item2">
                <a href="https://console.todesk.com/#/register" class="itemBtn epBtn2">免费试用</a>
              </div>
              <a
                class="moreItem"
                href="https://www.todesk.com/mobile/#/pricing_enterprise.html"
              >
                <span>更多安全功能和权益</span>
                <span class="moreItemIcon"></span>
              </a>
            </div>
            <div class="contItem contItem4">
              <div class="item1">
                <h5 class="itemMainTitle">私有化部署</h5>
                <h6 class="itemSubTitle">
                  灵活定制本地部署方案<br />大型团队定制方案
                </h6>
              </div>
              <div class="features">
                <div class="fitem">
                  <img
                    class="fitem_img"
                    src="@/assets/remoteSupport/price_check4@2x.png"
                    alt=""
                  />
                  <p class="fitem_text">本地服务器部署</p>
                </div>
                <div class="fitem">
                  <img
                    class="fitem_img"
                    src="@/assets/remoteSupport/price_check4@2x.png"
                    alt=""
                  />
                  <p class="fitem_text">数据自主掌控</p>
                </div>
                <div class="fitem fitemlast">
                  <img
                    class="fitem_img"
                    src="@/assets/remoteSupport/price_check4@2x.png"
                    alt=""
                  />
                  <p class="fitem_text">多种传输方式兼顾安全与性能</p>
                </div>
              </div>
              <div class="item2">
                <a href="/#/contact_mobile" class="itemBtn2 epBtn1">咨询客户经理</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    pageView: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less">
.section9 {
  background: linear-gradient(152deg, #669dde 0%, #0065dd 100%);
  .cont {
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
    max-width: 100%;
    .contBx {
      box-sizing: border-box;
      padding-bottom: 40px;
    }
    .contItems {
      margin: auto;
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .contItem {
        position: relative;
        justify-content: space-between;
        width: 345px;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 4px 18px 0px rgba(88, 95, 105, 0.14);
        border-radius: 3px;
        padding-top: 40px;
        text-align: center;
        padding-left: 25px;
        padding-right: 25px;
        margin-left: 12px;
        margin-right: 12px;
        .ciImg {
          position: absolute;
          right: -1px;
          top: -11px;
          height: 41px;
          width: auto;
        }

        .item1 {
          .itemMainTitle {
            text-align: center;
            line-height: 36px;
            font-size: 26px;
          }

          .itemSubTitle {
            margin-left: -5px;
            margin-right: -5px;
            text-align: center;
            font-size: 14px;
            line-height: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #88898d;
          }
        }
        .features {
          height: 135px;
          padding-top: 42px;
          padding-bottom: 23px;
          box-sizing: border-box;
          .fitem {
            display: flex;
            align-items: center;
            margin-bottom: 14px;
            .fitem_img {
              width: 18px;
              height: auto;
              margin-right: 8px;
            }
            .fitem_text {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #74777a;
              line-height: 1;
            }
          }
          .fitemlast {
            margin-bottom: 0;
          }
        }
        .item2 {
          text-align: center;
          margin-bottom: 24px;

          .itemBtn {
            display: block;
            width: 270px;
            line-height: 50px;
            line-height: 50px;
            font-size: 16px;
          }
          .itemBtn2 {
            display: block;
            width: 270px;
            line-height: 50px;
            font-size: 16px;
          }
        }
      }
      .contItem3 {
        border-top: 12px solid #30d1aa;
      }
      .contItem4 {
        border-top: 12px solid #ffbd33;
      }
    }
    .contSub {
      margin-top: 75px;
      text-align: center;
      opacity: 0.75;
      font-size: 18px;
      line-height: 25px;
      color: #fff;
      .contSubLink {
        display: inline;
        margin-left: 2px;
        text-decoration: underline !important;
      }
    }
  }
  // 技术支持页
  &.tech {
    .contTitle2 {
      display: block;
    }
    .cont .contBx {
      max-height: 1140px;
    }
  }
}
.moreItem {
  display: block;
  font-size: 14px;
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  color: #0065dd;
  cursor: pointer;
  .moreItemIcon {
    margin-top: 2px;
    display: block;
    width: 16px;
    height: 16px;
    margin-left: 2px;
    background-image: url(~@/assets/remoteSupport/icon_right@2x.png);
    background-size: 16px auto;
    background-repeat: no-repeat;
  }
}
</style>
